import { useQuery } from "@apollo/client";
import { WIDTH_SM } from "@constants/global";
import { useWindowWidth } from "@react-hook/window-size";
import EventCard from "components/Event/EventCard";
import NoEventCard from "components/Event/NoEventsCard";
import { Card } from "components/ui/v2";
import { gqlActivities } from "gql";
import {
  IGetAllActivityInput,
  IGetAllActivityResponse
} from "gql/Activities/queries";
import {
  isCacheValid,
  useExploreWidgetsCacheRefresh,
  useExploreWidgetsStore
} from "stores/explore/useExploreWidgetsStore";
import { Placeholder } from "rsuite";
import { Swiper, SwiperSlide } from "swiper/react";

const AvailableEvents = () => {
  const wWidth = useWindowWidth();
  const paddingSite = 16 * 2;
  const sizeWidth = wWidth - paddingSite;
  const isMobile = wWidth <= WIDTH_SM;
  const { events, setEvents, hasHydrated } = useExploreWidgetsStore();
  useExploreWidgetsCacheRefresh();
  const hasValidCache = isCacheValid(events.lastFetched);

  const { data: queriedActivitiesData, loading: loadingActivities } = useQuery<
    IGetAllActivityResponse,
    { getAllActivityInput: IGetAllActivityInput }
  >(gqlActivities.queries.GET_ACTIVITIES_LIGHT, {
    variables: {
      getAllActivityInput: {
        searchText: "",
        sortByStartDate: true
      }
    },
    skip: !hasHydrated || hasValidCache,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setEvents(data?.activities ?? []);
    }
  });

  const activities = hasValidCache
    ? events.data || []
    : queriedActivitiesData?.activities || events.data || [];

  return (
    <Card
      size="full"
      variant="default"
      tone="default"
      padding="none"
      shadow="subtle"
    >
      <Swiper
        slidesPerView={1}
        spaceBetween={20}
        navigation={activities.length > 1 ? true : false}
        className="rounded-xl"
        style={{
          width: isMobile ? sizeWidth : 268,
          height: 400
        }}
        autoplay
      >
        {loadingActivities && activities.length === 0 && (
          <SwiperSlide>
            <Placeholder.Graph
              active
              width={isMobile ? sizeWidth : 268}
              height={400}
              style={{
                borderRadius: "1rem"
              }}
            />
          </SwiperSlide>
        )}
        {activities.length === 0 && !loadingActivities && (
          <SwiperSlide>
            <NoEventCard />
          </SwiperSlide>
        )}
        {activities.map((item) => (
          <SwiperSlide key={item.id}>
            <EventCard {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Card>
  );
};

export default AvailableEvents;
